// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__223LI","list":"BalanceDue_list__2Wi7z","listRow":"BalanceDue_listRow__XJS0w","total":"BalanceDue_total__uFFQx"};